import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Start from "../Start";
import Home from "../Home";
import Empreendimento from "../Empreendimento";
import QrRedirect from "../QrRedirect";
import NoTenant from "../NoTenant";
import { useConfig } from "../../context/ConfigContext";
import { getSlug } from "../../tenant";

export default function Routes() {
  const slug = getSlug();
  const { appConfig } = useConfig();

  // Branded landing (same as the root URL) when there's no client to serve:
  // either no slug in the URL, or a slug whose config failed to load — i.e. no
  // such client. Gating here covers every inner route (start/home/empreendimento/
  // qr), so an unknown tenant never reaches a component's own error screen.
  if (!slug || (appConfig.loaded && appConfig.error)) {
    return <NoTenant />;
  }

  // basename = /{slug}, so all inner routes and <Link>s stay slug-relative
  // ("/", "/home", "/empreendimento/:id") with no per-component changes.
  return (
    <BrowserRouter basename={"/" + slug}>
      <Switch>
        <Route path="/" exact component={Start} />
        <Route path="/home" exact component={Home} />
        <Route path="/empreendimento/:id" exact component={Empreendimento} />
        {/* QR scan capture: records the scan (slot 8) then redirects to ?u= */}
        <Route path="/qr" exact component={QrRedirect} />
        {/* Unknown path under a valid slug: branded landing, same as the root. */}
        <Route component={NoTenant} />
      </Switch>
    </BrowserRouter>
  );
}
